import { createContext } from "react"
import type { PaymentBillServiceResponse } from "../types"

export const BillContext = createContext<PaymentBillServiceResponse>({
  approve_by: null,
  approve_status: 0,
  bill_id: 0,
  coa_id: "",
  deposit_amount: 0,
  memo: "",
  payment_amount: 0,
  purchase_order_id: 0,
  referensi: "",
  transaction_date: "",
  trx_code: "",
  databill: {
    address: "",
    balance: 0,
    location_id: "",
    saldo_deposit: 0,
    trx_code: "",
    vendor_id: "",
    vendor_name: ""
  }
})